import React from 'react'
import NavLinks from './NavLinks';

export const WebNav = () => {
  return (
    <nav className='webNav'>
      <NavLinks /></nav>
  )
}
